import { Link } from "react-router-dom";
import Logo from "./Logo";

const CATS = [
  ["Gift Boxes", "gift"],
  ["Pizza Boxes", "pizza"],
  ["Cake Boxes", "cake"],
  ["Burger Boxes", "burger"],
  ["Chalk Boxes", "chalk"],
  ["Juice Holders", "juice"],
  ["Round Takeaway Boxes", "takeaway"],
  ["Paper Bags", "bags"],
  ["Packaging Boxes", "packaging"],
  ["Corrugated Boxes", "corrugated"],
];

export default function Footer() {
  return (
    <footer className="bg-[#011a14] border-t border-mint/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <Logo size={30} />
            <span className="font-display font-semibold text-xl text-kraft tracking-wide">MUBFAR</span>
          </div>
          <p className="text-sm text-kraft/55 leading-relaxed max-w-sm">
            Custom box makers in Kampala, Uganda. Every box cut, printed and folded to
            your size — quoted fast, made properly.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-mintsoft/80 mb-5">The Range</p>
          <ul className="space-y-3 text-sm">
            {CATS.map(([label, slug]) => (
              <li key={slug}>
                <Link to={`/shop?category=${slug}`} data-testid={`footer-cat-${slug}`} className="text-kraft/60 hover:text-mint transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-mintsoft/80 mb-5">Store</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop" data-testid="footer-shop" className="text-kraft/60 hover:text-mint transition-colors">Shop all boxes</Link></li>
            <li><Link to="/quote" data-testid="footer-quote" className="text-kraft/60 hover:text-mint transition-colors">Start a quote</Link></li>
            <li><Link to="/faq" data-testid="footer-faq" className="text-kraft/60 hover:text-mint transition-colors">Questions & answers</Link></li>
            <li><Link to="/fast-food" data-testid="footer-fastfood" className="text-kraft/60 hover:text-mint transition-colors">Fast food packaging</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-mintsoft/80 mb-5">Find us</p>
          <ul className="space-y-3 text-sm text-kraft/60">
            <li data-testid="footer-address">
              <a
                href="https://maps.app.goo.gl/m6Jyrt38pHZPTj7J8"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-google-maps"
                className="hover:text-mint transition-colors"
              >
                Muzza Building, Nasser Rd,<br />Kampala, Uganda
              </a>
            </li>
            <li data-testid="footer-email">
              <a href="mailto:Mubirufaruku500@gmail.com" className="hover:text-mint transition-colors">Mubirufaruku500@gmail.com</a>
            </li>
            <li data-testid="footer-phone">
              <a href="tel:+256750928239" data-testid="footer-tel-1" className="hover:text-mint transition-colors">0750 928 239</a>
              <span className="text-kraft/30 mx-1.5">/</span>
              <a href="tel:+256781928239" data-testid="footer-tel-2" className="hover:text-mint transition-colors">0781 928 239</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-mint/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-wrap justify-between gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-kraft/35">
          <span>© {new Date().getFullYear()} MUBFAR500 · MADE IN KAMPALA</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-mint transition-colors">QUOTE INBOX →</Link>
          <span>NO PRICES LISTED — QUOTES ONLY</span>
        </div>
      </div>
    </footer>
  );
}
